export default __webpack_public_path__ + "static/media/yellow-electric-lightning-bolt-icon.4fc106ad.png";